import { createContext, useContext, useEffect, useState } from "react";

const PrefsCtx = createContext(null);
const read = (k, d) => {
  try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch { return d; }
};

export const FONT_SCALES = [0.9, 1, 1.125, 1.25];

export function PrefsProvider({ children }) {
  const [theme, setTheme] = useState(() => read("tr_theme", "dark"));
  const [fontScale, setFontScale] = useState(() => read("tr_font", 1));
  const [beginner, setBeginner] = useState(() => read("tr_beginner", true));
  const [largeTargets, setLargeTargets] = useState(() => read("tr_large", false));
  const [lang, setLang] = useState(() => read("tr_lang", "pt-BR"));

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    root.classList.toggle("large-targets", largeTargets);
    root.style.setProperty("--font-scale", fontScale);
    root.lang = lang;
    localStorage.setItem("tr_theme", JSON.stringify(theme));
    localStorage.setItem("tr_font", JSON.stringify(fontScale));
    localStorage.setItem("tr_beginner", JSON.stringify(beginner));
    localStorage.setItem("tr_large", JSON.stringify(largeTargets));
    localStorage.setItem("tr_lang", JSON.stringify(lang));
  }, [theme, fontScale, beginner, largeTargets, lang]);

  const stepFont = (dir) => {
    const i = FONT_SCALES.indexOf(fontScale);
    setFontScale(FONT_SCALES[Math.max(0, Math.min(FONT_SCALES.length - 1, (i < 0 ? 1 : i) + dir))]);
  };

  return (
    <PrefsCtx.Provider value={{ theme, setTheme, toggleTheme: () => setTheme(theme === "dark" ? "light" : "dark"),
      fontScale, setFontScale, stepFont, beginner, setBeginner, largeTargets, setLargeTargets, lang, setLang }}>
      {children}
    </PrefsCtx.Provider>
  );
}

export const usePrefs = () => useContext(PrefsCtx);
